import { subscribeConsent } from '@/contexts/consent/store';
import { hasDatadogConsent } from '@/lib/datadog/tracking-consent';
import {
    applyDatadogTrackingConsent,
    resetDatadogSdkIdentity,
    setDatadogSdkIdentity,
    writeDatadogLog,
} from '#datadog/runtime';

import { resetRumIdentity, updateRumIdentity } from '@/lib/datadog/rum';

export { hasDatadogConsent } from '@/lib/datadog/tracking-consent';

/** 业务提供真实 user_id，不在监控层获取 UserInfo 或使用 Auth subject。 */
export function setDatadogIdentity(user: { id: string; [key: string]: unknown }): void {
    if (!hasDatadogConsent() || !user.id.trim()) return;
    updateRumIdentity(user.id);
    setDatadogSdkIdentity(user);
}

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

function log(level: LogLevel, message: string, context?: Record<string, unknown>): void {
    // 未授权时静默丢弃；SDK 未初始化（非生产）时 logger 也是空操作。
    if (!hasDatadogConsent()) return;
    writeDatadogLog(level, message, context);
}

/** 业务诊断日志的唯一入口；Feature 不直接 import Datadog SDK。 */
export const datadogLogger = {
    debug: (message: string, context?: Record<string, unknown>) => log('debug', message, context),
    info: (message: string, context?: Record<string, unknown>) => log('info', message, context),
    warn: (message: string, context?: Record<string, unknown>) => log('warn', message, context),
    error: (message: string, context?: Record<string, unknown>) => log('error', message, context),
};

export function resetDatadogIdentity(): void {
    resetRumIdentity();
    resetDatadogSdkIdentity();
}

/** 同步订阅，不等待下一次 React render/effect 才收紧 SDK 授权。 */
export function subscribeDatadogConsent(): () => void {
    const sync = () => applyDatadogTrackingConsent(hasDatadogConsent());
    const unsubscribe = subscribeConsent(sync);
    sync();
    return () => {
        unsubscribe();
        applyDatadogTrackingConsent(false);
    };
}
